import { JSRuleErrorType } from "./JSRuleErrorType";

export class JSRuleError {

    #message: string;
    #type: JSRuleErrorType;

    constructor(type: JSRuleErrorType, message: string = '') {
        this.#type = type;
        this.#message = message;
    }

    get message(): string {
        return this.#message;
    }

    get type(): JSRuleErrorType {
        return this.#type;
    }

    toString(): string {
        let type = '';
        switch (this.#type) {
            case JSRuleErrorType.Value:
                type = '#VALUE!';
                break;
            case JSRuleErrorType.Type:
                type = '#TYPE!';
                break;
            case JSRuleErrorType.Reference:
                type = '#REF!';
                break;
        }
        return type + ' ' + this.#message;
    }

}